import {get} from 'common/utils/http';

const root = 'api/v1/train-tracker/';

// eslint-disable-next-line import/prefer-default-export
export const fetchTrainTrackerData = () => get(`${root}data`);
